// We only use the prod deeplink service env because the other envs have bad link urls
const apiVehicleDeeplinksBaseUrl = 'https://api.oneweb.mercedes-benz.com/vehicle-deeplinks-api';

const deeplinkAssetURL = '/content/dam/mb-nafta/us/dynamic-stage/dynamic-stage-deeplink.json';

export { deeplinkAssetURL, apiVehicleDeeplinksBaseUrl };
